import React from "react";
import {
  PrimaryButton,
  Spinner,
  SpinnerSize,
  Stack,
  Text,
} from "@fluentui/react";

const SubmitButton = ({ loading, text }) => {
  return (
    <PrimaryButton type="submit">
      <Stack
        tokens={{
          childrenGap: 10,
        }}
        verticalAlign={"center"}
        horizontal
      >
        {loading ? (
          <Spinner size={SpinnerSize.small} />
        ) : (
          <Text>{text || "Submit"}</Text>
        )}
      </Stack>
    </PrimaryButton>
  );
};

export default SubmitButton;
